import { buildApiUrl } from "../utils/apiConfig";
import { apiClient } from "../utils/apiClient";

export type CleverProvisionStudentRow = {
    email: string;
    firstName: string;
    lastName: string;
};

export type CleverProvisionCreated = {
    athleteProfileId: number | null;
    email: string;
};

export type CleverProvisionFailure = {
    email: string;
    message: string;
};

export type CleverProvisionBatchResponse = {
    created: CleverProvisionCreated[];
    failures: CleverProvisionFailure[];
};

export async function postCleverProvisionBatch(
    students: CleverProvisionStudentRow[]
): Promise<CleverProvisionBatchResponse> {
    const res = await apiClient(buildApiUrl("api/athletes/clever-provision"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ students }),
    });

    if (res.status === 401) {
        window.location.href = "/login";
        throw new Error("Unauthorized");
    }

    if (!res.ok) {
        let detail = `HTTP ${res.status}`;
        try {
            const err = await res.json();
            detail = err.detail || err.message || detail;
        } catch {
            /* ignore */
        }
        throw new Error(detail);
    }

    return res.json() as Promise<CleverProvisionBatchResponse>;
}
